import {
  Box,
  Stack,
  Heading,
  Text,
  Container,
  Input,
  Button,
  SimpleGrid,
  useBreakpointValue,
  Icon,
  Flex,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  FormControl,
  PinInputField,
  PinInput,
  HStack,
  Center,
  useColorModeValue,
  useToast,
  Image,
} from "@chakra-ui/react";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { useDispatch, useSelector } from "react-redux";
import { userLogin } from "../Redux/Auth/user.actions";
import { useLocation } from "react-router-dom";
import forlogin from "../assets/loginfor.png";
import { HiInformationCircle } from "react-icons/hi";
import { BASE_URL_USER } from "../Redux/App/action";

const Blur = (props) => {
  return (
    <Icon
      width={useBreakpointValue({ base: "100%", md: "40vw", lg: "30vw" })}
      zIndex={useBreakpointValue({ base: -1, md: -1, lg: 0 })}
      height="560px"
      viewBox="0 0 528 560"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="71" cy="61" r="111" fill="#F56565" />
      <circle cx="244" cy="106" r="139" fill="#ED64A6" />
      <circle cy="291" r="139" fill="#ED64A6" />
      <circle cx="80.5" cy="189.5" r="101.5" fill="#ED8936" />
      <circle cx="196.5" cy="317.5" r="101.5" fill="#ECC94B" />
      <circle cx="70.5" cy="458.5" r="101.5" fill="#48BB78" />
      <circle cx="426.5" cy="-0.5" r="101.5" fill="#4299E1" />
    </Icon>
  );
};
export default function Login() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = useRef(null);
  const finalRef = useRef(null);
  const inputRef = useRef(null);
  const inputRefOtp = useRef(null);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [phone, setPhone] = useState("");
  const [otpData, setOtpData] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const id = localStorage.getItem("id");
  const number = phone?.slice(-2);
  const [errorToastDisplayed, setErrorToastDisplayed] = useState(false);
  const finalOtp = otp.join("");
  const toast = useToast();
  const [timer, setTimer] = useState(60);
  const [isTimerActive, setIsTimerActive] = useState(false);
  const location = useLocation();
  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append("mobile", phone);
    dispatch(userLogin(formData));
  };
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
    if (inputRefOtp.current) {
      inputRefOtp.current.focus();
    }
  }, []);
  useEffect(() => {
    let interval;
    if (isTimerActive && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      setIsTimerActive(false);
    }

    return () => clearInterval(interval);
  }, [isTimerActive, timer]);

  const handleResendOtp = () => {
    axios
      .get(`${BASE_URL_USER}/public-api/v1/OTP/resend/${id}/LOGIN`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setTimer(60);
          setIsTimerActive(true);
        } else {
          toast({
            title: `Please try after sometime.`,
            status: "error",
            duration: 2000,
            position: "top",
            isClosable: true,
          });
        }
      })
      .catch((error) => {
        console.clear(`${error.message}`);

        if (!errorToastDisplayed) {
          toast({
            title: `Wrong Otp`,
            status: "error",
            duration: 2000,
            position: "top",
            isClosable: true,
          });

          setErrorToastDisplayed(true);
        }

        console.error(error);
      });
  };

  const handleOtpValidate = () => {
    const formData = new FormData();
    formData.append("otp", finalOtp);
    formData.append("requestId", id);
    axios
      .post(`${BASE_URL_USER}/public-api/v1/OTP/validate`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setOtpData(response.data);

          localStorage.setItem(
            "token",
            response.data?.payload?.token?.accessToken?.token
          );
          localStorage.setItem(
            "refresh",
            response.data?.payload?.token?.refreshToken?.token
          );
          const profileUpdated =
            response.data?.payload?.token?.accessToken?.token;
          const decoded = jwt_decode(profileUpdated);
          const checker = decoded.isProfileUpdated;
          const cardid = localStorage.getItem("cardid");
          setTimeout(() => {
            if (location.state?.from) {
              navigate(location.state.from);
              window.location.reload();
            } else if (location.state?.invite) {
              navigate(`/canvas/${cardid}`);
              window.location.reload();
            } else if (location.state?.greet) {
              navigate(location.state.greet);
              window.location.reload();
            } else if (location.state?.referrer) {
              navigate(location.state.referrer);
              window.location.reload();
            } else {
              if (checker) {
                navigate("/");
                toast({
                  title: "Login success",
                  status: "success",
                  duration: 5000,
                  position: "top",
                  isClosable: true,
                });
                window.location.reload();
              } else {
                navigate("/updateProfile");
                window.location.reload();
              }
            }
          }, 1000);
        }
      })
      .catch((error) => {
        console.clear(`${error.message}`);

        if (!errorToastDisplayed) {
          toast({
            title: `Wrong Otp`,
            status: "error",
            duration: 2000,
            position: "top",
            isClosable: true,
          });

          setErrorToastDisplayed(true);
        }

        console.error(error);
      });
  };

  const handleOtpChange = (index, event) => {
    const newOtp = [...otp];
    newOtp[index] = event.target.value;
    setOtp(newOtp);
  };

  //   const refresh_token = localStorage.getItem('refresh');
  //   const decodedRefreshToken = jwt_decode(refresh_token);
  // // Assuming the expiration time is stored in the 'exp' field of the decoded refresh token
  // const refreshExpirationTime = decodedRefreshToken.exp;

  // // Get the current time (in seconds)
  // const currentTime = Math.floor(Date.now() / 1000);

  // // Compare the expiration time with the current time
  // if (refreshExpirationTime < currentTime) {
  //   // The refresh token has expired
  //   console.log('Refresh token has expired');
  //   // Handle the case when the refresh token has expired
  // } else {
  //   // The refresh token is still valid
  //   console.log('Refresh token is still valid');
  //   // Proceed with token-based operations
  // }

  return (
    <Box position={"relative"}>
      <Container
        as={SimpleGrid}
        maxW={"7xl"}
        columns={{ base: 1, md: 2 }}
        spacing={{ base: 10, lg: 14 }}
        py={{ base: 10, sm: 20, lg: 10 }}
        mb={-10}
        mt={20}
      >
        <Stack
          rounded={"xl"}
          p={{ base: 4, sm: 6, md: 8 }}
          spacing={{ base: 8 }}
          maxW={{ lg: "lg" }}
        >
          <Stack spacing={4}>
            <Heading
              color={"gray.800"}
              lineHeight={1.1}
              fontSize={{ base: "2xl", sm: "3xl", md: "4xl" }}
              className="oswald-font"
            >
              Login
            </Heading>
            <Text
              className="lato-font"
              color={"#200E32"}
              fontSize={{ base: "sm", sm: "md" }}
              fontWeight={"semibold"}
            >
              Welcome to Wishfy, your ultimate destination for celebrating
              life's special moments!
            </Text>
          </Stack>
          <Box as={"form"}>
            <Text
              color={"#200E32"}
              fontSize={14}
              textAlign={"left"}
              mb={1}
              fontWeight={"semibold"}
            >
              Enter your mobile number
            </Text>
            <Stack spacing={4}>
              <Input
                ref={inputRef}
                placeholder="Mobile Number"
                bg={"gray.100"}
                type="number"
                name="mobile"
                border={0}
                color={"gray.500"}
                value={phone}
                _placeholder={{
                  color: "gray.500",
                }}
                onChange={(e) => {
                  let flag = true;
                  const inputValue = e.target.value;
                  if (inputValue.length === 1) {
                    if (
                      inputValue == 0 ||
                      inputValue == 1 ||
                      inputValue == 2 ||
                      inputValue == 3 ||
                      inputValue == 4 ||
                      inputValue == 5
                    ) {
                      flag = false;
                    }
                  }

                  if (flag && inputValue.length <= 10) {
                    setPhone(inputValue);
                  }
                }}
                onKeyDown={(e) => {
                  const enteredKey = e.key;
                  const currentPhone = phone;
                  if (
                    enteredKey === "ArrowLeft" ||
                    enteredKey === "ArrowRight"
                  ) {
                    return;
                  }

                  if (enteredKey === "Enter" && currentPhone.length === 10) {
                    e.preventDefault();
                    handleSubmit();
                    onOpen();
                  } else if (
                    enteredKey === "Enter" &&
                    currentPhone.length !== 10
                  ) {
                    e.preventDefault();
                    toast({
                      title: "Enter a valid 10-digit Number",
                      status: "error",
                      duration: 5000,
                      position: "top",
                      isClosable: true,
                    });
                  }
                  if (enteredKey === "." || enteredKey === "e") {
                    e.preventDefault();
                  }
                  if (enteredKey === "Backspace") {
                    return;
                  }
                  if (currentPhone.length >= 10) {
                    e.preventDefault();
                  }
                }}
                maxLength={10}
                pattern="^(?![01]|5|4|3|2|1)\d{10}"
                title="Please enter a valid 10-digit Indian mobile number"
              />
              <div>
                <p className="text-xs">
                  By continuing, you agree to the{" "}
                  <span className="underline">
                    <Link to={"/privacyPolicy"} target="_blank">
                      Privacy Policy{" "}
                    </Link>
                  </span>
                  and{" "}
                  <span className="underline">
                    <Link to={"/TermOfUse"} target="_blank">
                      Terms & Conditions
                    </Link>
                  </span>
                </p>
              </div>
            </Stack>

            <Flex
              alignItems={"center"}
              gap={2}
              justifyContent={"center"}
              mt={5}
            >
              <HiInformationCircle size={16} />
              <Text color={"#3E3E3E"} fontWeight={"semibold"} fontSize={14}>
                This cannot be changed later
              </Text>
            </Flex>

            <Button
              fontFamily={"heading"}
              mt={5}
              w={"65%"}
              bg={"#FC1A64"}
              color={"white"}
              fontWeight={"extrabold"}
              _hover={{
                bg: "#FC1A64",
              }}
              onClick={() => {
                const currentPhone = phone;
                if (currentPhone.length === 10) {
                  handleSubmit();
                  onOpen();
                  setTimer(60);
                  setIsTimerActive(true);
                } else {
                  toast({
                    title: "Enter a valid 10-digit Number",
                    status: "error",
                    duration: 5000,
                    position: "top",
                    isClosable: true,
                  });
                }
              }}
            >
              Request Otp
            </Button>
          </Box>
          <Modal
            isOpen={isOpen}
            onClose={onClose}
            initialFocusRef={initialRef}
            finalFocusRef={finalRef}
          >
            <ModalOverlay />
            <ModalContent>
              <ModalCloseButton />
              <ModalBody>
                <Flex align={"center"} justify={"center"}>
                  <Stack spacing={4} w={"full"} rounded={"xl"} p={2} my={5}>
                    <Center>
                      <Heading lineHeight={1.1} className="oswald-font">
                        Verify your OTP
                      </Heading>
                    </Center>
                    <Center
                      fontSize={{ base: "sm", sm: "md" }}
                      color={useColorModeValue("gray.800", "gray.400")}
                      className="lato-font"
                    >
                      We have sent code to your Mobile
                    </Center>
                    <Center
                      fontSize={{ base: "sm", sm: "md" }}
                      fontWeight="bold"
                      color={useColorModeValue("gray.800", "gray.400")}
                      className="lato-font"
                    >
                      {`********${number}`}
                    </Center>
                    <FormControl>
                      <Center>
                        <HStack>
                          <PinInput otp>
                            <PinInputField
                              value={otp[0]}
                              onChange={(e) => handleOtpChange(0, e)}
                              autoFocus
                            />
                            <PinInputField
                              value={otp[1]}
                              onChange={(e) => handleOtpChange(1, e)}
                            />
                            <PinInputField
                              value={otp[2]}
                              onChange={(e) => handleOtpChange(2, e)}
                            />
                            <PinInputField
                              value={otp[3]}
                              onChange={(e) => handleOtpChange(3, e)}
                            />
                            <PinInputField
                              value={otp[4]}
                              onChange={(e) => handleOtpChange(4, e)}
                            />
                            <PinInputField
                              value={otp[5]}
                              onChange={(e) => handleOtpChange(5, e)}
                              onBlur={() => {
                                if (otp[5] && otp[5].length === 1) {
                                  handleOtpValidate();
                                }
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  handleOtpValidate();
                                }
                              }}
                            />
                          </PinInput>
                        </HStack>
                      </Center>
                    </FormControl>
                    <Stack spacing={6}>
                      <Button
                        bg={"#FF1C6B"}
                        color={"white"}
                        _hover={{
                          bg: "#FF1C6B",
                        }}
                        onClick={() => {
                          handleOtpValidate();
                        }}
                      >
                        Verify
                      </Button>
                      {isTimerActive ? (
                        <Text>Resend OTP in {timer} seconds</Text>
                      ) : (
                        <Button
                          onClick={() => {
                            handleResendOtp();
                          }}
                          colorScheme="blue"
                        >
                          Resend OTP
                        </Button>
                      )}
                    </Stack>
                  </Stack>
                </Flex>
              </ModalBody>
            </ModalContent>
          </Modal>
        </Stack>
        <Box>
          <Image src={forlogin} mt={"-8"} w={"80%"} />
        </Box>
      </Container>
    </Box>
  );
}
